<div class="modal-header bg-white">
    <h4 class="text-start">{{ heading != '' && heading != null? heading : 'Address Default' }}</h4>
    <button type="button" class="btn-close" aria-label="Close"><i class="fa-solid fa-xmark"
            (click)="activeModal.dismiss(false)"></i></button>
</div>
<div class="modal-body delete-box">
    <h3>{{titleContent}}</h3>
    <p>{{title}}
    </p>
    <p *ngIf="date != '' || date != null">{{date}}</p>
    <div class="btn-group text-center d-flex mt-4">
        <a class="btn btn-primary w-50 mt-3" aria-label="Close" (click)="activeModal.dismiss(true)">
            {{commonConstant.yes}}
        </a>
        <a class="btn btn-light w-50 mt-3 ms-2" (click)="activeModal.dismiss(false)">
            {{commonConstant.no}}
        </a>
    </div>
</div>